import React, { useState } from "react";

const getHostname = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./i, "");
  } catch {
    return "";
  }
};

export const SourceChip = ({ url, index = 0 }) => {
  const [iconFailed, setIconFailed] = useState(false);
  const hostname = getHostname(url);
  if (!hostname) return null;

  return (
    <a
      className="ea-source-chip"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={url}
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <span className="ea-source-chip__icon" aria-hidden="true">
        {iconFailed ? (
          hostname.charAt(0).toUpperCase()
        ) : (
          <img
            src={`https://www.google.com/s2/favicons?domain=${hostname}&sz=32`}
            alt=""
            loading="lazy"
            onError={() => setIconFailed(true)}
          />
        )}
      </span>
      <span className="ea-source-chip__label">{hostname}</span>
    </a>
  );
};

const SourceChips = ({ urls = [] }) => {
  const uniqueUrls = [...new Set(urls.filter((url) => getHostname(url)))];
  if (!uniqueUrls.length) return null;

  return (
    <div className="ea-sources">
      <div className="ea-sources__label">
        Sources
        <span className="ea-sources__count">{uniqueUrls.length}</span>
      </div>
      <div className="ea-sources__list">
        {uniqueUrls.map((url, index) => (
          <SourceChip key={url} url={url} index={index} />
        ))}
      </div>
    </div>
  );
};

export default SourceChips;
